import React, { useMemo } from 'react';

import { Avatar, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getColorByUserId } from 'constants/presence';
import { getPersonInitials } from 'utils/loanApplication';

import { AiChatTestIds } from '../../../../AiChat.testIds';

import { getAvatarStyles, wrapperStyles } from './UserMessageAvatar.styles';

const UserMessageAvatar = ({ userId, displayName }) => {
  const color = useMemo(() => getColorByUserId(userId), [userId]);

  const initials = useMemo(() => {
    const parts = (displayName ?? '').trim().split(/\s+/).filter(Boolean);
    const firstName = parts[0] ?? '';
    const lastName = parts.length > 1 ? parts[parts.length - 1] : '';

    return getPersonInitials({ firstName, lastName }).toUpperCase();
  }, [displayName]);

  const avatarStyles = useMemo(() => getAvatarStyles(color), [color]);

  return (
    <Box data-testid={AiChatTestIds.USER_MESSAGE_AVATAR} sx={wrapperStyles}>
      <Avatar sx={avatarStyles}>
        <Typography color="text.secondary" variant="medium12">
          {initials}
        </Typography>
      </Avatar>
    </Box>
  );
};

UserMessageAvatar.propTypes = {
  userId: PropTypes.string,
  displayName: PropTypes.string,
};

export default UserMessageAvatar;
